import{hasKeyOfType as t}from"../../../utils";export var isWebkitVideoElement=function(e){return t(e,"webkitSetPresentationMode","function")};